import {get} from '../utils'

export default host => profileUrl =>
  get(`${host}/contentCreators/checkProfileUrl?profile_url=${profileUrl}`)
    .then(response => response.json())
